import { AllergenTagChip } from '@ordo/ui/tag-chip'
import { TriangleAlert } from 'lucide-react'

import type { StudentAllergenWire } from '@/api/cafeteria'
import type { DeliverableLineBucket } from '@/lib/cafeteria/format'

import { BucketChip } from './bucket-chip'

/** Student allergies lead the existing diet/milk strip on the card and in its modal. */
export function StudentTags({
  allergens = [],
  tags,
}: {
  allergens?: ReadonlyArray<StudentAllergenWire>
  tags: ReadonlyArray<DeliverableLineBucket>
}) {
  return (
    <>
      {allergens.map((allergen) => (
        <AllergenTagChip
          key={allergen.id}
          emphasized
          data-allergen-id={allergen.id}
          aria-label={`${allergen.label} allergy`}
          className="max-w-full gap-1 whitespace-normal rounded-full px-2 py-0.5 text-sm font-medium leading-5 tracking-normal">
          <TriangleAlert className="size-3.5 shrink-0" aria-hidden />
          <span className="min-w-0 break-words">{allergen.label}</span>
        </AllergenTagChip>
      ))}
      {tags.map((bucket) => (
        <BucketChip key={`${bucket.code ?? ''}::${bucket.label}`} bucket={bucket} />
      ))}
    </>
  )
}
